// extracted by mini-css-extract-plugin
export default {"changelog":"btn-changelog-module--changelog--3JTc7"};